import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "text-right text-xs text-gray-500 ml-auto" }
const _hoisted_3 = ["innerHTML"]

import moment from "moment";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { INotificationItem } from "../models/Notifications";
const DELETE_NOTIFICATION = "deleteNotification";
const DELETE_ALL_NOTIFICATION = "deleteAllNotification";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationItem',
  props: {
    notification: {},
    maxMessageLength: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const isLoaded = ref(false);
const notificationIcon = () => {
  switch (props.notification?.type) {
    case "application":
      return "fa-solid fa-user-plus";
    case "position":
      return "fa-solid fa-rocket";
    case "alert":
    case "error":
      return "fa-solid fa-circle-exclamation";
    default:
      return "fa-solid fa-star";
  }
};
onMounted(() => {
  isLoaded.value = true;
});
const truncatedMessage = (message: string) => {
  if (message?.length > props.maxMessageLength) {
    return message.substring(0, props.maxMessageLength - 3) + "...";
  }
  return message;
};
const emit = __emit;

const store = useStore();

const toggleNotificationReadStatus = async (id: number) => {
  if (props.notification?.read) {
    await store.dispatch("markAsUnread", props.notification.id);
  } else {
    await store.dispatch("markAsRead", props.notification.id);
  }
};

const deleteNotification = async (id: INotificationItem) => {
  emit(DELETE_NOTIFICATION, id);
};

const dateDiff = moment(props.notification?.timestamp).diff(moment(), "days");
console.log(dateDiff);

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["grid grid-cols-[auto,auto,1fr,auto] grid-rows-[auto,1fr] place-items-center w-full px-2 py-2 text-sm transition gap-y-0 gap-x-4 cursor-pointer", 
      props.notification?.read === false
        ? 'bg-blue-4 hover:bg-blue-3 hover:bg-opacity-40 '
        : 'bg-white hover:bg-gray-3'
    ])
      }, [
        _createElementVNode("div", {
          title: 
        !props.notification?.read ? 'Markera som läst' : 'Markera som oläst'
      ,
          class: _normalizeClass(["h-3 w-3 rounded-full row-span-full", !props.notification?.read ? 'bg-blue-3' : 'bg-gray-2']),
          onClick: _cache[0] || (_cache[0] = () => toggleNotificationReadStatus(props.notification.id))
        }, null, 10, _hoisted_1),
        _createElementVNode("div", {
          class: "grid place-content-center h-8 w-8 rounded-full bg-blue-3 row-span-full",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (props?.notification?.callback && props?.notification?.callback(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["text-white", notificationIcon()])
          }, null, 2)
        ]),
        _createElementVNode("p", {
          class: "font-semibold place-self-start",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (props?.notification?.callback && props?.notification?.callback(...args)))
        }, _toDisplayString(props.notification?.title), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(dateDiff) === 0
          ? _unref(moment).unix(props.notification?.timestamp).format("HH:mm")
          : _unref(moment)
              .unix(props.notification?.timestamp)
              .format("YYYY-MM-DD HH:mm")), 1),
        _createElementVNode("p", {
          class: "text-gray-500 grid-cols-2 place-self-start max-w-[40ch]",
          innerHTML: truncatedMessage(props.notification?.message),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (props?.notification?.callback && props?.notification?.callback(...args)))
        }, null, 8, _hoisted_3),
        _createElementVNode("button", {
          class: "text-xs text-red-2 hover:text-red-2 justify-self-end self-start",
          onClick: _cache[4] || (_cache[4] = () => deleteNotification(props.notification))
        }, " Ta bort ")
      ], 2))
    : _createCommentVNode("", true)
}
}

})